<section>
    <button class="billing-trigger" [class.blinking]="!isOpen" (click)="toggle()"
        aria-label="Billing alert — click to expand">
        <div class="trigger-icon" aria-hidden="true"></div>
    </button>

    <div *ngIf="isOpen" class="billing-banner" [class.open]="isOpen" role="alert" aria-live="polite">
        <div class="banner-icon-wrap">
            <div class="banner-icon" aria-hidden="true"></div>
        </div>
        <div class="banner-body">
            <p class="banner-title">Your bill is overdue — features paused</p>
            <button class="banner-action" routerLink="/billing/bills">Resolve now &nbsp;→</button>
        </div>
        <button class="banner-close" (click)="close($event)" aria-label="Dismiss">✕</button>
    </div>
</section>